// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"5e9753c4","559":"f638f8ee","686":"2d156ac1","962":"076b54dc"}[chunkId] + ".chunk.css";
};